// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"164e4a5e","977":"b4bfd673"}[chunkId] + ".chunk.js";
};